import Ui3DotsMenu from '../../../dictionaries/Ui3DotsMenu.dic';
import Core from '../../../lib/Core';
import {
  ACCOUNT_ACTION__EDIT_ACCOUNT
} from '../../../lib/Definition';
import globalErrorHandler from '../../../lib/Error/globalErrorHandler.fun';
import {
  getAccountModel
} from '../../../lib/models/account';
import orderJsonProperties from '../../../lib/Object/orderJsonProperties.fun';
import {
  COLLECTION__ACCOUNTS
} from '../../../lib/services/BE/loopback.api';
import {
  compileText
} from '../../../lib/String.lib';
import {
  matchLocation
} from '../../../lib/URL.lib';
import Typography from '../../Layout/Wrappers/Typography';
import {
  getControllerSampleJsonData
} from '../../Tools/SampleJsonData';

export const moreMenuOptionsAccounts = [
  {
    acl: account => (Core.isAdmin({ action: ACCOUNT_ACTION__EDIT_ACCOUNT }) || (Core.isRecruiter() && Core.isOnDev())),
    to: account => (`/account/edit/${account.id}`),
    label: (
      <Typography>
        {compileText(Ui3DotsMenu.Common.editEntity, {
          ENTITY: matchLocation(/\/(create|edit)/i) ? '' : Ui3DotsMenu.Account.ENTITY
        })}
      </Typography>
    ),
  },
  {
    acl: candidate => Core.isAdmin(),
    label: 'Admin only: model view',
    action: (account) => getControllerSampleJsonData().updateState({
      collection: COLLECTION__ACCOUNTS,
      jsonDataA: orderJsonProperties({
        data: getAccountModel({ extended: true })
      }),
      id: account.id,
    }).then(
      () => setTimeout(
        () => getControllerSampleJsonData().fetchData({ id: account.id }),
        100
      )
    ).catch(globalErrorHandler)
  },
];
